import { render, staticRenderFns } from "./project-management.vue?vue&type=template&id=aa0c48a6"
import script from "./project-management.vue?vue&type=script&lang=js"
export * from "./project-management.vue?vue&type=script&lang=js"
import style0 from "./project-management.vue?vue&type=style&index=0&id=aa0c48a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports